import { AbstractControl, ValidatorFn } from '@angular/forms';

export const validUrlValidator: ValidatorFn = ({ value }: AbstractControl<string>) => {
  const scheme = 'https://';
  const url = 'docs.google.com/spreadsheets/';
  const idChars = /^(?:d\/)?([a-zA-Z0-9-_]{2,})(?:[#/=?].*)?$/i;

  if (value.startsWith(scheme)) {
    value = value.slice(scheme.length);
  }

  const isValid = value.startsWith(url) && idChars.test(value.slice(url.length));
  return isValid ? null : { invalidUrl: true };
};
